$(window).scroll(function(){
	if($(document).scrollTop() > 100){
		$('.scroll-down').css('opacity', 0.01);				
	}else{
		$('.scroll-down').css('opacity', 1);
	}
});
function initHeros(){
    "use strict";
	$('.scroll-down').click(function(){
		$('body,html').animate({scrollTop:$(window).innerHeight()}, '1000');
		return false;		
	});
}	
